function ZonesControls() {
    "use strict";

    this.CardView = null;
    this.CardViewTimer = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;
    this.Map = null;
    this.MapLocate = null;
    this.Validator = null;
    this.NotificationPanel = null;
    this.LegendDropdown = null;
    this.DetailsDropdown = null;
    this.LocateDropdown = null;
    this.NotesDropdown = null;
    this.SettingsDropdown = null;
}
if (typeof exports !== 'undefined') {
    module.exports = ZonesControls;
}